import React, {Component} from 'react';
import moment from 'moment';
import {capitalizeFirstWord} from "@assets/js/functions/helpers";

import DayPickerInput from "react-day-picker/DayPickerInput";
import 'react-day-picker/lib/style.css';

import MomentLocaleUtils, {formatDate, parseDate} from 'react-day-picker/moment';
import 'moment/locale/pl';
import 'moment/locale/en-gb';
import 'moment/locale/de';

export default class ArrivalDepartureInputs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            from: undefined,
            to: undefined,
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        const primitives = [undefined, null, '', 'NaN-NaN-NaN'];
        let {initialDates: {from, to}} = this.props;

        from = !primitives.includes(from) ? moment(from, moment.defaultFormat).toDate() : undefined;
        to = !primitives.includes(to) ? moment(to, moment.defaultFormat).toDate() : undefined;

        this.setState({from, to})
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    getNumberOfMonths = () => {
        if (window.outerWidth > 768) {
            return 2;
        }

        return 1;
    }

    handleChange(date, dateType) {
        const dateCollided = this.isDateColliding(date, dateType);
        const dateExceededMaxRange = this.isDateExceedingMaxRange(date, dateType);

        if (!date || dateExceededMaxRange) return;

        if (dateCollided) {
            this.handleCollidedDate(date, dateType)
        } else if (dateType === 'from' && this.state.from) {
            this.setState({
                from: date
            }, () => {
                this.changeFocusTo(this.dayPickerToLabel);
            })
        } else {
            this.setState({
                [dateType]: date
            }, () => {
                this.changeDateFilter()
                this.changeFocusTo(this.dayPickerToLabel);
            })
        }
    }

    isDateColliding = (dateToCheck, type) => {
        const stateDateTo = this.state.to;
        const stateDateFrom = this.state.from;

        if (type === 'from' && stateDateTo) {
            return moment(stateDateTo).diff(moment(dateToCheck)) < 0;
        }

        if (type === 'to' && stateDateFrom) {
            return moment(stateDateFrom).diff(moment(dateToCheck)) > 0;
        }
    }

    handleCollidedDate = (date, dateType) => {
        let dateFilter;
        let callBack;

        if (dateType === 'from') {
            dateFilter = {
                from: date,
                to: undefined
            }

            callBack = () => {
                this.changeFocusTo(this.dayPickerToLabel);
            }
        } else {
            dateFilter = {
                from: undefined,
                to: date
            }

            callBack = () => {
                this.changeFocusTo(this.dayPickerFromLabel)
            }
        }

        this.setState(dateFilter, callBack);
    }

    isDateExceedingMaxRange = (date, dateType) => {
        if (!moment(date).isValid()) return;

        const {from, to} = this.state;
        const momentDateFrom = moment(from);
        const momentDateTo = moment(to);
        const momentDateToCheck = moment(date);

        if (from || to) {
            const twoMonthsInMilliseconds = 5184000000;
            const diffDates = (dateType === 'to') ?
                moment.duration(momentDateToCheck.diff(momentDateFrom)).asMilliseconds() :
                moment.duration(momentDateTo.diff(momentDateToCheck)).asMilliseconds()

            return diffDates > twoMonthsInMilliseconds;
        }
    }

    changeFocusTo = (focusTo) => {
        // click on a label provides a lag so the setTimeout is needed to get focus
        setTimeout(() => {
            focusTo.focus();
        }, 100)
    }

    changeDateFilter = () => {
        this.props.onChangeFilter({
            date_from: this.state.from ? moment(this.state.from).format('YYYY-MM-DD') : null,
            date_to: this.state.to ? moment(this.state.to).format('YYYY-MM-DD') : null,
        })
    }

    render() {
        const {from, to} = this.state;
        const modifiers = {start: from, end: to};
        const {translations} = this.props;
        const minimalDate = new Date().toISOString().slice(0, 10);
        const disabledTo = moment(from, moment.defaultFormat).add(2, 'months').toDate();

        return (
            <div className="InputFromTo day-picker">
                <div className="fromDayPicker">
                    <label
                        className="filter-title"
                        ref={el => (this.dayPickerFromLabel = el)}
                    >
                        {capitalizeFirstWord(translations['from'])}
                        <DayPickerInput
                            id="date-from"
                            value={from}
                            placeholder={translations['arrival']}
                            format="YYYY-MM-DD"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            dayPickerProps={{
                                selectedDays: [from, {from, to}],
                                disabledDays: {before: new Date(minimalDate)},
                                max: new Date(2019, 2, 20),
                                modifiers,
                                numberOfMonths: this.getNumberOfMonths(),
                                localeUtils: MomentLocaleUtils,
                                locale: 'pl',
                            }}
                            onDayChange={date => this.handleChange(date, 'from')}
                        />
                        <img className="day-picker__icon" src='/img/icons/icon-calendar.svg' alt=""/>
                    </label>
                </div>
                <div className="toDayPicker day-picker">
                    <label
                        className="filter-title"
                        ref={el => (this.dayPickerToLabel = el)}
                    >
                        {capitalizeFirstWord(translations['input-to'])}
                        <DayPickerInput
                            ref={el => (this.dayPickerTo = el)}
                            value={to}
                            placeholder={translations['departure']}
                            format="YYYY-MM-DD"
                            formatDate={formatDate}
                            parseDate={parseDate}
                            dayPickerProps={{
                                id: "bookingDateTo",
                                selectedDays: [from, {from, to}],
                                disabledDays: {
                                    before: new Date(minimalDate),
                                    after: new Date(disabledTo)
                                },
                                modifiers,
                                month: from,
                                numberOfMonths: this.getNumberOfMonths(),
                                localeUtils: MomentLocaleUtils,
                                locale: 'pl'
                            }}
                            onDayChange={date => this.handleChange(date, 'to')}
                        />
                        <img className="day-picker__icon" src='/img/icons/icon-calendar.svg' alt=""/>
                    </label>
                </div>
            </div>);
    }
};
